/* eslint-disable import/extensions */
import React, { useState, useEffect } from 'react';
import { Button, Col, Form, Modal, Row, } from 'react-bootstrap';
import { FaCheck, FaXmark } from 'react-icons/fa6';
import { http, messages, layout, } from '@/helpers/index';

export default function FilterSaveModal({ options, }) {
  const titles = {
    dashboard: 'Dashboard',
    detailing: 'Detalhamento',
    users: 'Usuários',
    userCategories: 'Categorias de Usuário',
    userTypes: 'Tipos de Usuário',
    supportCategories: 'Categorias de Suporte',
    supportTypes: 'Tipos de Suporte',
    histories: 'Histórico de Utilização',
    orders: 'Vendas',
    prospects: 'Prospecções',
    inquiries: 'Serviços Realizados',
    coupons: 'Cupons',
    slides: 'Slides',
    templates: 'Templates',
    reportTemplates: 'Templates de Relatório',
    campaigns: 'Campanhas',
    blacklist: 'Blacklist',
    flows: 'Fluxos WhatsApp',
    logs: 'Logs',
    audit: 'Auditoria',
    scheduledTasks: 'Tarefas Agendadas',
    scheduledTasksMonitorinf: 'Tarefas Agendadas',
    issues: 'Pendências',
    configurations: 'Configurações',
    partner: 'Cadastrar Parceiro',
    vendors: 'Fornecedores',
    products: 'Produtos',
    testimonials: 'Depoimentos',
    videos: 'Vídeos',
    communications: 'Comunicações de Venda',
    diagnoses: 'Diagnósticos',
    consumptionMonitoring: 'Monitoramento de Consumo',
    testDriveMonitoring: 'Monitoramento de Test Drive',
    integrationMonitoring: 'Monitoramento de Integração',
    emailsMonitoring: 'Monitoramento de E-mails',
    monitors: 'Monitoramento',
    managerMix: 'MIX - Gerenciamento',
    monitorMix: 'MIX - Monitoramento',
    adminMix: 'MIX - Administração',
  };
  const initial = { name: '', key: options.key, data: options.filter, type: 'PRIVATE', status: 'ACTIVE' };
  const [item, setItem] = useState(options.item ?? initial);

  const handleCancel = () => {
    setItem(initial);
    options.hide();
  };

  const handleOnSubmit = (e) => {
    e.preventDefault();
    messages.clear();
    layout.loading(true);
    const id = item._id ? `/${item._id}` : '';
    http.base(item._id ? 'PUT' : 'POST', `/manager/filters${id}`, item, (result, resultError) => {
      handleCancel();
      layout.loading(false);
      if (result) {
        messages.success(`Filtro ${item.name} foi salvo com sucesso.`, null, true);
        options.update(result);
        return;
      }
      messages.error(resultError.message, null, true);
    });
  };

  const handleInputChange = ({ target }) => {
    setItem({ ...item, [target.name]: target.value });
  };

  useEffect(() => {
    layout.focus('name');
  }, []);

  return (
    <Modal
      show={options.show}
      onHide={handleCancel}
      backdrop="static"
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Form onSubmit={handleOnSubmit}>
        <Modal.Header closeButton>
          <div className="lead not-printable featurette-heading mt-1">Salvar Filtro</div>
        </Modal.Header>
        <Modal.Body>
          <h2>{`${titles[options.name]}`}</h2>
          <Row>
            <Col xs={12}>
              <Form.Group>
                <Form.Label htmlFor="name">Nome</Form.Label>
                <Form.Control
                  type="text"
                  id="name"
                  name="name"
                  onChange={handleInputChange}
                  value={item.name}
                />
              </Form.Group>
            </Col>
            <Col xs={12} sm={6}>
              <Form.Group className="mb-1">
                <Form.Label htmlFor="type">Tipo</Form.Label>
                <Form.Select name="type" size="sm" required value={item.type} onChange={handleInputChange}>
                  <option value="">Selecione o tipo</option>
                  <option value="PRIVATE">Privado</option>
                  <option value="PUBLIC">Público</option>
                </Form.Select>
              </Form.Group>
            </Col>
            <Col xs={12} sm={6}>
              <Form.Group className="mb-1">
                <Form.Label htmlFor="status">Status</Form.Label>
                <Form.Select name="status" size="sm" required value={item.status} onChange={handleInputChange}>
                  <option value="">Selecione o status</option>
                  <option value="ACTIVE">Ativo</option>
                  <option value="INACTIVE">Inativo</option>
                </Form.Select>
              </Form.Group>
            </Col>
          </Row>
        </Modal.Body>
        <Modal.Footer>
          <Button type="submit" size="sm" className="shadow-sm">
            <FaCheck className="me-1" />
            Salvar
          </Button>
          <Button variant="light" size="sm" className="shadow-sm" onClick={handleCancel}>
            <FaXmark className="me-1" />
            Fechar
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
}
